import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { BbAbstractMenuComponent } from '../shared/bb-abstract-menu/bb-abstract-menu.component';
import { RouterEvent, NavigationEnd } from '@angular/router';

@Component({
	selector: 'bb-adservices-menu',
	templateUrl: './bb-adservices-menu.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class BbAdservicesMenuComponent extends BbAbstractMenuComponent implements OnInit {
	constructor(
		private changeDetector: ChangeDetectorRef
	) {
		super(['dashboard', 'position', 'vastservice', 'creative', 'vastDetails', 'adschedule', 'auction']);
	}

	ngOnInit() {
		this.subscriptions.add(this.router.events.subscribe((routerEvent: RouterEvent) => {
			if (routerEvent instanceof NavigationEnd) {
				this.changeDetector.detectChanges();
			}
		}));
	}
}
